import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
export default function RBMSummaryTable({rows,Month1,Month2,Month3}) {

const columns = [
  { field: "id", headerName: "ID", width: 40, hide: true },

  {
    field: 'rbmname',
    headerName: 'RBM Name',
    width: 200,
    sortable: false,
  },
 
  {
    field: 'sum_m1_adjusted_budget_unit',
    headerName: `Adj.Bud U(${Month1})`,
    width: 150,
    sortable: true,
    align:'center',
    renderCell: (params, rowId) => {
      const value=(params.row.sum_m1_adjusted_budget_unit).toFixed(0)
      return (
        <p title={params.row.sum_m1_adjusted_budget_unit}  style={{align:"center"}}>
          {value}
        </p>
      );
    },
  },
  {
    field: 'sum_m1_adjusted_budget_value',
    headerName: `Adj.Bud V(${Month1})`,
    width: 150,
    sortable: true,
    align:'center'
  },
  // {
  //   field: 'sum_post_budget_adjustment_m1_rci',
  //   headerName: 'Post budget adjustment '+String(Month1)+' rci',
  //   width: 150,
  //   sortable: true,
  //   align:'center'
  // },
  {
    field: 'sum_m2_adjusted_budget_unit',
    headerName:  `Adj.Bud U(${Month2})`,
    width: 150,
    sortable: true,
    align:'center',
    renderCell: (params, rowId) => {
      const value=(params.row.sum_m2_adjusted_budget_unit).toFixed(0)
      return (
        <p title={params.row.sum_m2_adjusted_budget_unit}  style={{align:"center"}}>
          {value}
        </p>
      );
    },
  },
  {
    field: 'sum_m2_adjusted_budget_value',
    headerName: `Adj.Bud V(${Month2})`,
    width: 150,
    sortable: true,
    align:'center'
  },
  // {
  //   field: 'sum_post_budget_adjustment_m2_rci',
  //   headerName:'Post budget adjustment '+String(Month2)+' rci',
  //   width: 150,
  //   sortable: true,
  //   align:'center'
  // },
  {
    field: 'sum_m3_adjusted_budget_unit',
    headerName:  `Adj.Bud U(${Month3})`,
    width: 150,
    sortable: true,
    align:'center',
    renderCell: (params, rowId) => {
      const value=(params.row.sum_m3_adjusted_budget_unit).toFixed(0)
      return (
        <p title={params.row.sum_m3_adjusted_budget_unit}  style={{align:"center"}}>
          {value}
        </p>
      );
    },
  },
  {
    field: 'sum_m3_adjusted_budget_value',
    headerName: `Adj.Bud V(${Month3})`,
    width: 150,
    sortable: true,
    align:'center'
  },
  // {
  //   field: 'sum_post_budget_adjustment_m3_rci',
  //   headerName: 'Post budget adjustment '+String(Month3)+' rci',
  //   width: 150,
  //   sortable: true,
  //   align:'center'
  // },
  
];


  return (
    <div style={{ height: 480, width: '100%' }}>
      <DataGrid
        rows={rows}
        Month1={Month1}
        Month2={Month2} 
        Month3={Month3}
        columns={columns}
        pageSize={15}
        rowsPerPageOptions={[15]}
        density='compact'
      />
    </div>
  );
}
